import {CustomEmojisModel} from '../../../models/api/customEmojiModel';
import {AppAction} from '../../appActions';
import {CustomEmojiActionsEnum} from './customEmojiActions';

export function customEmojiReducer(state: CustomEmojisModel, action: AppAction): CustomEmojisModel {
  switch (action.type) {
    case CustomEmojiActionsEnum.CUSTOM_EMOJIS_INITIALIZED:
      return action.payload;

    case CustomEmojiActionsEnum.CUSTOM_EMOJIS_CREATED:
      return {
        route: state.route,
        shortcodes: state.shortcodes.concat([action.payload]),
      };

    case CustomEmojiActionsEnum.CUSTOM_EMOJIS_DELETED:
      return {
        route: state.route,
        shortcodes: state.shortcodes.filter((s) => s !== action.payload),
      };

    default:
      return state;
  }
}
